import { generateUUID } from '@business/utils/uuid';
export const isAddonShoppingCartItem = (item) => item.type === 'addon';
export const isAccommodationShoppingCartItem = (item) => item.type === 'accommodation';
export const buildLinkingId = ({ adults, kids, packageId = '0', roomId, unit = 'x', // We can't use 0 as default cause unit 0 is a valid one
 }) => [roomId, packageId, unit, adults, kids].join('-');
export default class ShoppingCartItem {
    constructor(data, uuid) {
        Object.defineProperty(this, "id", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "model", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "getItemId", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: () => { var _a; return (_a = this.model) === null || _a === void 0 ? void 0 : _a.item.id; }
        });
        Object.defineProperty(this, "getLinkingId", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: () => isAccommodationShoppingCartItem(this.model)
                ? buildLinkingId({
                    adults: this.model.adults,
                    kids: this.model.kids,
                    packageId: this.model.item.packageId,
                    roomId: this.model.item.id,
                    unit: this.model.unit,
                })
                : buildLinkingId({
                    adults: this.model.item.adults,
                    kids: this.model.item.kids,
                    packageId: this.model.item.packageId,
                    roomId: this.model.item.roomId,
                    unit: this.model.unit,
                })
        });
        this.model = data;
        if (data.type === 'addon') {
            this.id = uuid || generateUUID();
            return;
        }
        const { adults, kids, unit } = data;
        const { packageId, id: roomId } = data.item;
        this.id = buildLinkingId({
            adults,
            kids,
            packageId,
            roomId,
            unit,
        });
    }
    getName() {
        var _a, _b, _c;
        if (this.model.type === 'accommodation') {
            if (this.model.unit) {
                return `${this.model.item.name} - ${this.model.unit}`;
            }
        }
        return ((_a = this.model) === null || _a === void 0 ? void 0 : _a.type) === 'accommodation'
            ? (_b = this.model) === null || _b === void 0 ? void 0 : _b.item.name
            : (_c = this.model) === null || _c === void 0 ? void 0 : _c.item.name.getText();
    }
    get isAlreadyPurchased() {
        var _a, _b;
        return (((_b = (_a = this.model) === null || _a === void 0 ? void 0 : _a.item) === null || _b === void 0 ? void 0 : _b.bookedId) || []).length > 0;
    }
}
